import styled from '@emotion/styled';
import { computed } from 'mobx';
import { AppUI, ExerciseUI } from '@seedlang/state';
import { isPresent } from '@seedlang/utils';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { isFunction } from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import EpisodeCode from 'components/episode_code';

const TagDisplay = styled.div`
  background: #FFF;
  color: #343535;
  padding: 3px 8px;
  font-size: 11px;
  line-height: 12px;
  height: 22px;
  margin: 3px 3px 0 0;
  border-radius: 15px;
  font-weight: bold;
  border: 1px solid #cbcccb;
  cursor: ${props => props.isClickable ? 'pointer' : 'default'};
  white-space: nowrap;
  &:hover {
    box-shadow: ${props => props.isClickable ? '0 0 6px rgba(33,33,33,.2)' : ''}; 
  }
  &:active {
    box-shadow: ${props => props.isClickable ? 'inset 0 0 6px rgba(33,33,33,.2)' : ''};
  }
`;

const EditTagsButton = styled(TagDisplay)`
  background: #228BE6;
  color: white;
`

const Wrapper = styled.div`
  display: flex;
  width: ${props => props.width};
  justify-content: space-between;
  align-items: flex-end;
`;

const TagDisplayWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const EpisodeCodeWrapper = styled.div`
  font-size: 14px;
  color: #616161;
  margin-top: 5px;
  text-wrap: nowrap;
`;

@observer
class Tags extends React.Component {

  static defaultProps = {
    width: '100%',
  };

  @computed get activeView() {
    if (ExerciseUI.worksheetNamespace === 'worksheets') return 'Home';
    if (ExerciseUI.worksheetNamespace === 'videos') return 'Videos';
    if (ExerciseUI.worksheetNamespace === 'podcast') return 'Podcast';
    return null;
  }
  @computed get worksheetFilterClickable() {
    return AppUI.site.showWorksheetFilter && isPresent(this.props.worksheet);
  }

  onClickWorksheetTag = (tags) => {
    if (!this.worksheetFilterClickable) return;
    if (isPresent(tags)) {
      const tagIds = tags?.map(tag => tag.id).join(',');
      AppUI.cookieStore.set(`worksheetTagIds${this.activeView}`, tagIds || null);
      this.afterClickTag();
    }
  }
  onClickWorksheetLevels = () => {
    if (!isPresent(this.props.worksheet)) return;
    this.onClickWorksheetTag(this.props.worksheet.levelTags);
  }
  afterClickTag = () => {
    if (isFunction(this.props.onUpdateFilter)) {
      this.props.onUpdateFilter();
    }
  }

  @computed get tagSource() {
    if (isPresent(this.props.worksheet)) {
      return this.props.worksheet;
    }
    return this.props.exercise;
  }

  @computed get levelTags() {
    const source = this.tagSource;
    if (!isPresent(source)) {
      return null;
    }
    if (AppUI.routeStore.routeName === 'videos.index') {
      return source.levelTags.filter(item => item.displayOnVideoWorksheets);
    }
    if (AppUI.routeStore.routeName === 'podcast.index') {
      return source.levelTags.filter(item => item.displayOnPodcastWorksheets);
    }
    return source.levelTags;
  }

  @computed get tags() {
    if (isPresent(this.props.worksheet)) {
      if (isPresent(AppUI.routeStore.routeName)) {
        return this.props.worksheet?.tagsForRouteName(AppUI.routeStore.routeName);
      }
      return this.props.worksheet?.orderedTags;
    }
    if (isPresent(this.props.exercise)) {
      return this.props.exercise?.orderedTags;
    }
    return [];
  }

  render() {
    return (
      <Wrapper width={this.props.width}>
        <TagDisplayWrapper>
            {
              isPresent(this.levelTags) &&
                <TagDisplay
                  key={`${this.tagSource.id}-level-tags`}
                  onClick={this.onClickWorksheetLevels}
                  isClickable={this.worksheetFilterClickable}
                >
                  {this.tagSource.levelTagsFormatted}
                </TagDisplay>
            }
            {
              isPresent(this.tags) && this.tags.map(tag => {
                if (tag?.name && tag?.tagCategoryPublished && !tag.level) {
                  return (
                    <TagDisplay
                      key={tag.id}
                      onClick={() => this.onClickWorksheetTag([tag])}
                      isClickable={this.worksheetFilterClickable}
                    >
                      {tag.name}
                    </TagDisplay>
                  );
                } else {
                  return null;
                }
              })
            }
            {
              this.props.withEditButton && (
                <EditTagsButton
                  onClick={() => this.props.onEditTags()}
                  isClickable
                >
                  Edit tags
                </EditTagsButton>
              )
            }
        </TagDisplayWrapper>
         {
            this.props.episodeCode &&
            <EpisodeCodeWrapper><EpisodeCode episodeCode={this.props.episodeCode} /></EpisodeCodeWrapper>
          }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(Tags);
